class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimeout = null;
  }

  connectedCallback() {
    super.connectedCallback?.();
    this.setupHoverBehavior();
  }

  setupHoverBehavior() {
    if (!this.mainDetailsToggle || !this.mainDetailsToggle.classList.contains('header-menu-dropdown')) return;

    const headerWrapper = document.querySelector('.header-wrapper');
    const trigger = headerWrapper?.getAttribute('data-menu-trigger') || 'hover';
    if (trigger === 'click') return;

    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

    const open = () => {
      if (!isDesktop()) return;
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      if (this.hoverCloseTimeout) {
        clearTimeout(this.hoverCloseTimeout);
        this.hoverCloseTimeout = null;
      }
    };

    const close = () => {
      if (!isDesktop()) return;
      this.hoverCloseTimeout = setTimeout(() => {
        this.close();
        this.hoverCloseTimeout = null;
      }, 150);
    };

    const cancelClose = () => {
      if (this.hoverCloseTimeout) {
        clearTimeout(this.hoverCloseTimeout);
        this.hoverCloseTimeout = null;
      }
    };

    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      cancelClose();
      open();
    });

    this.mainDetailsToggle.addEventListener('mouseleave', close);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    this.updateMenuOpenState();

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  updateMenuOpenState() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    const anyMenuOpen = headerWrapper.querySelector('header-menu details[open]');
    if (anyMenuOpen) {
      headerWrapper.classList.add('menu-submenu-open');
      const bottom = headerWrapper.getBoundingClientRect().bottom;
      headerWrapper.style.setProperty('--header-menu-overlay-top', `${bottom}px`);
    } else {
      headerWrapper.classList.remove('menu-submenu-open');
    }
    headerWrapper.dispatchEvent(new CustomEvent('headerMenuToggle', { bubbles: true }));
  }
}

customElements.define('header-menu', HeaderMenu);
